import generateRender from './generateRender';
import theme from '../assets/style/theme';
var scrollBarTrackColor = generateRender({
  default: theme.palette.secondary[27],
  sga: theme.palette.secondary[41]
});
var scrollBarThumbColor = generateRender({
  default: theme.palette.primary[34],
  sga: 'rgba(241, 133, 76, 1)'
});
export { scrollBarTrackColor, scrollBarThumbColor };